import { RegionalPricing } from "@/components/app/regional-pricing";
import { useTranslation } from "@/lib/paraglide-react";
import { Route } from "/app/src/routes/{-$locale}/offers/$id/price.tsx";
const SplitComponent = () => {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  return <section id="offer-information" className="h-full w-full">
        <h2 className="text-xl md:text-2xl font-bold mb-4">{t("offerDetail.price.title")}</h2>
        <RegionalPricing id={id} />
      </section>;
};
export { SplitComponent as component };